import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import {categoriaSituacao} from './situacaoInscricao.js';

const useStyles = makeStyles(theme => ({
    chip: {
        fontWeight: 500,
        color: theme.palette.common.white
    },
    sucesso: {backgroundColor: theme.palette.quinary.main},
    erro: {backgroundColor: theme.palette.error.main},
    pendente: {
        backgroundColor: theme.palette.senary.main,
        color: theme.palette.text.primary
    },
    atencao: {backgroundColor: theme.palette.warning.dark},
    info: {backgroundColor: theme.palette.tertiary.main},
    neutro: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.text.primary
    },
    quadrado: {
        display: 'inline-block',
        flexShrink: 0,
        width: 12,
        height: 12,
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
        marginRight: theme.spacing(1),
        verticalAlign: 'middle'
    }
}));

/* Quadradinho com a cor da situação (a mesma do chip), para usar antes do nome em listas de opções. */
export function CorSituacaoInscricao(props) {
    const {codigo} = props;
    const classes = useStyles();

    return <span aria-hidden='true' className={clsx(classes.quadrado, classes[categoriaSituacao(codigo)])}/>;
}

CorSituacaoInscricao.propTypes = {
    codigo: PropTypes.string
};

/* Situação da inscrição como etiqueta colorida (a cor vem do código da situação). */
export default function StatusSituacaoInscricao(props) {
    const {situacao} = props;
    const classes = useStyles();

    if (!situacao) {
        return null;
    }

    return (
        <Chip
            size='small'
            label={situacao.descricao}
            className={clsx(classes.chip, classes[categoriaSituacao(situacao.codigo)])}/>
    );
}

StatusSituacaoInscricao.propTypes = {
    situacao: PropTypes.shape({
        codigo: PropTypes.string,
        descricao: PropTypes.string
    })
};
